export default __webpack_public_path__ + "static/media/m_foodieBooster13.baf0e639.png";